import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  flex-direction: column;\n  z-index: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  z-index: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ", ";\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, forwardRef, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { position } from 'styled-system';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { Portal } from '../portal/Portal';
import { ModalHeader, ModalBody, ModalFooter } from '../modal/Modal';
import { Icon } from '../icon/Icon';
import { Button } from '../button/Button';
import { Box, Flex } from '../grid/Grid';
var placementStyleMap = {
  top: {
    top: 0,
    left: 0,
    right: 0,
    height: 231
  },
  bottom: {
    bottom: 0,
    left: 0,
    right: 0,
    height: 231
  },
  right: {
    right: 0,
    top: 0,
    bottom: 0,
    width: 400
  },
  left: {
    left: 0,
    top: 0,
    bottom: 0,
    width: 400
  }
};
var Mask = styled(Box)(_templateObject(), themeGet('colors.blacks.5'), themeGet('zIndex.modalMask'));
var CloseButton = styled(Button).attrs({
  variant: 'link'
})(_templateObject2(), themeGet('drawer.closeButton.top'), themeGet('drawer.closeButton.right'), themeGet('drawer.closeButton.size'), themeGet('drawer.closeButton.size'), themeGet('drawer.closeButton.backgroundColor'), themeGet('drawer.closeButton.borderRadius'), themeGet('zIndex.fixed'));
var CloseButtonIcon = styled(Icon).attrs({
  name: 'CLOSE',
  color: 'blacks.3'
})(_templateObject3(), themeGet('drawer.closeButton.size'), themeGet('drawer.closeButton.size'), themeGet('drawer.closeButton.color'));
var Content = styled(Flex)(_templateObject4(), themeGet('zIndex.modal'), themeGet('drawer.content.boxShadow'), themeGet('drawer.content.backgroundColor'), themeGet('drawer.content.border'), themeGet('drawer.content.borderRadius'), themeGet('drawer.content.borderColor'), position);
export var Drawer =
/*#__PURE__*/
forwardRef(function Drawer(_ref, ref) {
  var children = _ref.children,
      show = _ref.show,
      closeButton = _ref.closeButton,
      onClose = _ref.onClose,
      _ref$maskClosable = _ref.maskClosable,
      maskClosable = _ref$maskClosable === void 0 ? true : _ref$maskClosable,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'right' : _ref$placement,
      props = _objectWithoutProperties(_ref, ["children", "show", "closeButton", "onClose", "maskClosable", "placement"]);

  useEffect(function () {
    show ? disableBodyScroll() : clearAllBodyScrollLocks();
  }, [show]);
  return show &&
  /*#__PURE__*/
  React.createElement(Portal, null,
  /*#__PURE__*/
  React.createElement(Mask, {
    onClick: maskClosable && onClose
  },
  /*#__PURE__*/
  React.createElement(Content, _extends({}, placementStyleMap[placement], props, {
    ref: ref,
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }),
  /*#__PURE__*/
  React.isValidElement(closeButton) ? closeButton : closeButton &&
  /*#__PURE__*/
  React.createElement(CloseButton, {
    variant: "link",
    onClick: onClose
  },
  /*#__PURE__*/
  React.createElement(CloseButtonIcon, null)), children)));
});
export var DrawerHeader =
/*#__PURE__*/
forwardRef(function DrawerHeader(_ref2, ref) {
  var props = _extends({}, _ref2);

  var _useContext = useContext(ThemeContext),
      defaultHeaderStyle = _useContext.drawer.header;

  var defaultFontSize = defaultHeaderStyle.heading.fontSize;
  return (
    /*#__PURE__*/
    React.createElement(ModalHeader, _extends({
      ref: ref,
      fontSize: defaultFontSize
    }, defaultHeaderStyle, props))
  );
});
export var DrawerBody =
/*#__PURE__*/
forwardRef(function DrawerBody(_ref3, ref) {
  var props = _extends({}, _ref3);

  var _useContext2 = useContext(ThemeContext),
      defaultBodyStyle = _useContext2.drawer.body;

  return (
    /*#__PURE__*/
    React.createElement(ModalBody, _extends({
      ref: ref,
      flex: 1,
      overflowY: "auto"
    }, defaultBodyStyle, props))
  );
});
export var DrawerFooter =
/*#__PURE__*/
forwardRef(function DrawerFooter(_ref4, ref) {
  var props = _extends({}, _ref4);

  var _useContext3 = useContext(ThemeContext),
      defaultFooterStyle = _useContext3.drawer.footer;

  return (
    /*#__PURE__*/
    React.createElement(ModalFooter, _extends({
      ref: ref
    }, defaultFooterStyle, props))
  );
});